<template>
    <div class="back">
        <div class="isola" ref="container">
          
            <button 
                class="button is-normal isClose"
                @click="closeMe"
            >
                <span class="icon is-medium">
                <i class="fas fa-close"></i>
                </span>
            </button>

            <!-- <button
                type="button"
                class="close imgClose"
                aria-label="Close"
                @click="closeMe">
                <span class="previewX" aria-hidden="true">&times;</span>
            </button> -->
            <div>
                <!-- <div class="image-container"> -->

                <img
                    :src="currentImage"
                    class="border bigImage"
                    @load="handleImageLoad"
                    ref="imageEl"
                />
                      
                    
                <!-- </div> -->
            </div>
            <div>
                <!-- <button class="arrow left" >
                    &lt;
                </button>
                <button
                    class="arrow right"
                    >
                    &gt;
                </button> -->
                <button class="button is-medium left"
                    @click="prevImage" 
                    :disabled="currentIndex === 0"
                >
                    <span class="icon is-medium">
                    <i class="fa-solid fa-arrow-left"></i>
                    </span>
                </button>
                <button class="button is-medium right"
                    @click="nextImage"
                    :disabled="currentIndex === images.length - 1"
                >
                    <span class="icon is-medium">
                    <i class="fa-solid fa-arrow-right"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            images: {
                type: Array,
                required: true
            },
            initialIndex: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {currentIndex: this.initialIndex}
        },
        computed: {
            currentImage() {
                return this.images[this.currentIndex];
            }
        },
        methods: {
            closeMe() {
                this.$emit('close')
            },
            handleImageLoad(event) {
                const img = event.target
                const container = this.$refs.container
                const aspectRatio = img.naturalWidth / img.naturalHeight

                container.style.aspectRatio = `${aspectRatio}`
                container.style.maxWidth = '90vw'
                container.style.maxHeight = '90vh'
            },
            nextImage() {
                if (this.currentIndex < this.images.length - 1) {
                    this.currentIndex++
                }
            },
            prevImage() {
                if (this.currentIndex > 0) {
                    this.currentIndex--
                }
            }
        },
        watch: {
            initialIndex(newVal) {
                this.currentIndex = newVal;
            }
        }
    }
</script>

<style scoped="scoped">
    .back {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1999;
    }

    .isola {
        position: relative;
        /* background: white; */
        background: var(--bulma-background);
        border-radius: 15px;
        margin: auto;
        padding: 5px;
        box-sizing: border-box;
        max-width: 90vw;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        padding-bottom: 2vh;
    }

    .border {
        border: 3px solid rgba(156, 156, 156, 0.224);
        border-radius: 12px;
        width: 100%;
        height: fit-content;
        overflow: hidden;
        /* display: flex; */
        /* justify-content: center; */
        /* align-items: center; */
    }

    .image-container {
        /* position: relative; */
        /* display: flex; */
        /* align-items: center; */
        /* justify-content: center; */
        width: 100%;
        /* height: 100%; */
        min-width: 300px;
        min-height: 200px;
    }

    .bigImage {
        max-width: 100%;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        /* padding: 10px; */
    }

    .imgClose {
        position: absolute;
        top: 4px;
        right: 15px;
        font-size: 2rem;
        z-index: 2000;
        color: #666;
        opacity: 0.8;
        transition: opacity 0.2s;
        background: none;
        border: none;
        cursor: pointer;
        background-color: white;
        height:3.5vw;
        width: 3.5vw;
        border-radius: 100%;
    }

    .imgClose:hover {
        opacity: 1;
    }

    .arrow {
        position: absolute;
        /* top: 50%; */
        /* transform: translateY(-50%); */
        font-size: 2.5rem;
        color: white;
        background: rgba(0, 0, 0, 0.5);
        border: none;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        /* display: flex; */
        /* align-items: center; */
        /* justify-content: center; */
        /* cursor: pointer; */
        z-index: 10;
        transition: background 0.3s;
    }

    .arrow:hover:not(:disabled) {
        background: rgba(0, 0, 0, 0.8);
    }

    .arrow:disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }

    .left {
        /* position:absolute; */
        left: 5.5vw;
    }

    .right {
        position:absolute !important;
        right: 5.5vw;
    }
    .isClose{
        align-items: center;
        position: absolute;
        right: 2.5vw;
        top: 2vw;
        border-radius: 100%;
        opacity: 0.8 !important;
    }
</style>